import { getAPIEndPoint } from "../consts/APIEndpoints";
import { getResponse } from "../utils/common";

export async function getEnabledToggles(upn) {
  return getResponse(
    `${getAPIEndPoint()}features`,
    "get"
  );
}
